module.exports = __webpack_public_path__ + "img/ja-logo-name.42603f09.svg";